"use client";

export const FotStudent = () => {
	return (
		<div
			className={
				"flex flex-col items-center  w-1/1 bg-sky-100 rounded p-6 gap-5 shadow-2xl"
			}
		>
			<p className={"text-2xl font-bold text-sky-600"}>学生の方はこちら！</p>
			<button
				type="button"
				className={
					"shadow bg-sky-600 text-white w-72 rounded-full text-xl p-2 font-bold "
				}
				onClick={(): void => {
					window.open(
						"https://docs.google.com/forms/d/1SGyWiaKaSoP00VR0XpAJV8KTz0MYeOcr9HqtsYXVseY/viewform",
					);
				}}
			>
				応募フォーム
			</button>
		</div>
	);
};
